import axios from 'services/axios';
import { default as mockAxios } from 'utils/axios';
import moment from 'moment';
import { API } from 'services/constants';

const createAction = name => ({
  TRANSFER_COMPANY_CHANGE: `${name}_TRANSFER_COMPANY_CHANGE`,
  TRANSFER_ACCOUNT_CHANGE: `${name}_TRANSFER_ACCOUNT_CHANGE`,
  TRANSFER_RECEIPT_CHANGE: `${name}_TRANSFER_RECEIPT_CHANGE`,
  TRANSFER_QR_TYPE_CHANGE: `${name}_TRANSFER_QR_TYPE_CHANGE`,
  TRANSFER_START_DATE_CHANGE: `${name}_TRANSFER_START_DATE_CHANGE`,
  TRANSFER_END_DATE_CHANGE: `${name}_TRANSFER_END_DATE_CHANGE`,
  TRANSFER_STATUS_CHANGE: `${name}_TRANSFER_STATUS_CHANGE`,
  GET_TRANSFER_PENDING: `${name}_GET_TRANSFER_PENDING`,
  GET_TRANSFER_SUCCESS: `${name}_GET_TRANSFER_SUCCESS`,
  GET_TRANSFER_FALIED: `${name}_GET_TRANSFER_FALIED`
});

export const TRANSFER = createAction('TRANSFER');

export const TransferCompanyChange = value => dispatch => {
  dispatch({
    type: TRANSFER.TRANSFER_COMPANY_CHANGE,
    payload: value
  });
};

export const TransferReceiptChange = value => dispatch => {
  dispatch({
    type: TRANSFER.TRANSFER_RECEIPT_CHANGE,
    payload: value
  });
};

export const TransferStatusChange = value => dispatch => {
  dispatch({
    type: TRANSFER.TRANSFER_STATUS_CHANGE,
    payload: value
  });
};

export const TransferAccountChange = value => dispatch => {
  dispatch({
    type: TRANSFER.TRANSFER_ACCOUNT_CHANGE,
    payload: value
  });
};

export const TransferQrTypeChange = value => dispatch => {
  dispatch({
    type: TRANSFER.TRANSFER_QR_TYPE_CHANGE,
    payload: value
  });
};

export const TransferStartDateChange = date => dispatch => {
  dispatch({
    type: TRANSFER.TRANSFER_START_DATE_CHANGE,
    payload: date
  });
};

export const TransferEndDateChange = date => dispatch => {
  dispatch({
    type: TRANSFER.TRANSFER_END_DATE_CHANGE,
    payload: date
  });
};

export const GetMockTransfer = () => async (dispatch, getState) => {
  dispatch({ type: TRANSFER.GET_TRANSFER_PENDING });
  try {
    const result = await mockAxios
      .get('/api/tranfer')
      .then(res => res.data)
      .catch(err => Promise.reject(err));

    dispatch({
      type: TRANSFER.GET_TRANSFER_SUCCESS,
      payload: result
    });
  } catch (error) {
    dispatch({
      type: TRANSFER.GET_TRANSFER_FALIED,
      error
    });
  }
};

export const GetTransfer = () => async (dispatch, getState) => {
  dispatch({ type: TRANSFER.GET_TRANSFER_PENDING });
  try {
    const { authen, settlement } = getState();

    const { loginUser } = authen;
    const { companyId, startDate, endDate, qrType } = settlement;
    const _companyId = companyId !== 'Select all' ? companyId : '';
    const _qrType = qrType !== 'Select all' ? qrType : '';
    const params = {
      companyId: loginUser.role === 'super' ? _companyId : loginUser.companyId,
      start: moment(startDate).format('YYYY-MM-DD'),
      end: moment(endDate).format('YYYY-MM-DD'),
      qrType: _qrType
    };

    const result = await axios
      .post(API.GET_INQUIRY_TRANSACTION, params)
      .then(res => res.data)
      .catch(err => Promise.reject(err));
    dispatch({
      type: TRANSFER.GET_TRANSFER_SUCCESS,
      payload: result
    });
  } catch (error) {
    dispatch({
      type: TRANSFER.GET_TRANSFER_FALIED,
      error
    });
  }
};
